/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MeetingNotificationsEnsureParams } from './meetingNotificationsEnsureParams';

/**
 * Request model for meeting notifications ensure job
 */
export interface RunMeetingNotificationsEnsureJobRequest {
  type: 'meeting_notifications_subscriptions_ensure';
  params: MeetingNotificationsEnsureParams;
  allowOverlappingJobs?: boolean;
}
